import React, { useCallback } from 'react'
import loadComponent from 'src/utils/loadMFE'
import { useNavigate } from 'react-router-dom'
import RouteContainer from 'src/components/App/RouteContainer'

const EventParticipationCalendar = React.lazy(() => loadComponent('traiwiss', 'ParticipationCalendar'))

export function EventParticipationCalendarRoute() {
    const navigate = useNavigate()

    const gotoTrainingDetails = useCallback(
        (trainingId: string) => {
            navigate(`/trainings/${trainingId}`)
        },
        [navigate],
    )

    return (
        <RouteContainer>
            <EventParticipationCalendar gotoTrainingDetails={gotoTrainingDetails} />
        </RouteContainer>
    )
}
